import { useContext } from 'react';

import { GaugeChartShowThresholdIndicatorsContext } from '../contexts/GaugeChartShowThresholdIndicatorsContext.js';

export const useGaugeChartShowThresholdIndicatorsContext = () =>
  useContext(GaugeChartShowThresholdIndicatorsContext);
